import { Check } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
export function ProgressStatusFinished({ label }: { label: string }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: 24, display: 'flex', justifyContent: 'center' }}>
        <Check color="success" sx={{ fontSize: 20 }} />
      </Box>
      <Typography sx={{ ml: 2 }}>{label}</Typography>
    </Box>
  );
}
